import clsx from "clsx";
import { FunctionComponent, RefObject } from "react";

import type { Props as CommentCountProps } from "@voxmedia/duet-ui/components/meta/CommentCount";
import CskStoryNavigation from "src/components/CskStoryNavigation";
import SubscribeNavOverlay from "src/components/SubscribeNavOverlay";
import * as shellStyles from "src/config/story-shell-global-styles.css";
import { vergeGetDrawerComponents } from "src/config/verge-drawer-components";
import { useRevealNavVisibility } from "src/hooks/use-reveal-nav-visibility";

interface Props {
  /** Element whose offscreen state reveals the nav (typically the lede). */
  revealAfterRef: RefObject<HTMLElement | null>;
  /** When true, subscribe chrome follows theme-contract overrides. */
  themeEnabled?: boolean;
  /** When true, hamburger drawer includes the theme switcher (Rivian-style). */
  drawerThemeSwitcher?: boolean;
  commentCountProps?: CommentCountProps | null;
}

/**
 * Scroll-reveal nav: CSK minimal bar + subscribe overlay, hidden until the lede
 * scrolls offscreen.
 */
const CskRevealNav: FunctionComponent<Props> = ({
  revealAfterRef,
  themeEnabled = false,
  drawerThemeSwitcher = false,
  commentCountProps,
}) => {
  const showNav = useRevealNavVisibility(revealAfterRef);
  const revealClassName = clsx(
    shellStyles.revealNavChromeItem,
    showNav && shellStyles.revealNavChromeItemVisible,
  );

  return (
    <>
      <CskStoryNavigation
        minimalNavClassName={revealClassName}
        getDrawerComponents={
          drawerThemeSwitcher ? vergeGetDrawerComponents : undefined
        }
      />
      <SubscribeNavOverlay
        className={revealClassName}
        themeEnabled={themeEnabled}
        commentCountProps={commentCountProps}
      />
    </>
  );
};

export default CskRevealNav;
